module.exports = __webpack_public_path__ + "img/map-icon-blue.46239054.svg";